import Box from "@mui/material/Box";
import MzProgress from "@markaaz/ui/MzProgress";

const sx = {
  root: {
    display: "flex",
    height: "60vh",
    justifyContent: "center",
    svg: {
      width: "80px",
      circle: {
        fill: (theme) => theme.palette.blue.c100
      }
    }
  }
};

export default function Loading() {
  return (
    <Box sx={sx.root}>
      <MzProgress />
    </Box>
  );
}
